/* eslint-disable react/prop-types */
import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/modal";
import { Button } from "@nextui-org/button";
import React, { useEffect, useRef, useState } from "react";
import AppUtility, { imageFileExtension } from "../assets/js/AppUtility";
import { uploadFileService } from "../services/BlobService";
import AppConstant from "../assets/js/AppConstant";
import useClaimStore from "../stores/useClaimStore";
import AdjustAmountForm from "./AdjustAmountForm";

const AttachClaimDocumentModal = ({
  isOpen,
  onOpenChange,
  onConfirm,
  currentSubTicket,
}) => {
  const fileInputRef = useRef(null);
  const [selectFiles, setSelectFiles] = useState([]);
  const [formData, setFormData] = useState({
    claim_amount: null,
    select_file_urls: [],
  });

  const { getClaimById } = useClaimStore();

  useEffect(() => {
    if (isOpen && currentSubTicket) {
      const claimData = getClaimById(currentSubTicket.id);
      if (claimData) {
        setFormData({
          select_file_urls: [],
        });

        const fileUrls = claimData.sub_tickets.claim_file_urls;

        if (Array.isArray(fileUrls) && fileUrls.length > 0) {
          const existingFileMaps = fileUrls.map((url) => {
            const extension = url.split(".").pop().toLowerCase();
            const isImage = imageFileExtension.includes(extension);
            const dummyFile = new File([""], url, {
              type: isImage ? "image/jpeg" : "application/pdf",
            });

            return new Map([[dummyFile, url]]);
          });

          setSelectFiles(existingFileMaps);
          setFormData((prev) => ({
            ...prev,
            select_file_urls: existingFileMaps,
          }));
        }
      }
    }
  }, [isOpen, currentSubTicket, getClaimById]);

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        claim_amount: null,
        select_file_urls: [],
      });
      setErrors({});
      setSelectFiles([]);
    }
  }, [isOpen]);

  const [errors, setErrors] = useState({});

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    try {
      const uuid = AppUtility.uuidv4();
      const dateTimeIso = new Date(
        new Date().getTime() + 7 * 60 * 60 * 1000
      ).toISOString();
      const fileExtension = file.name.split(".").pop();
      const fileName = `${dateTimeIso}_PROPOSAL_${uuid}.${fileExtension}`;

      const uploadedUrl = await uploadFileService(file, file.type, fileName);

      const fileMap = new Map([[file, uploadedUrl]]);

      setSelectFiles((prevFiles) => [...prevFiles, fileMap]);

      setFormData((prevData) => ({
        ...prevData,
        select_file_urls: Array.isArray(prevData.select_file_urls)
          ? [...prevData.select_file_urls, fileMap]
          : [fileMap],
      }));
    } catch (_) {
      setSelectFiles((prevFiles) => prevFiles.filter((f) => f !== file));
    }
  };

  const removeFile = (index) => {
    setSelectFiles(selectFiles.filter((_, i) => i !== index));
    setFormData((prevData) => ({
      ...prevData,
      select_file_urls: prevData.select_file_urls.filter((_, i) => i !== index),
    }));
  };

  const validateForm = (data) => {
    const errors = {};

    if (!selectFiles.length) {
      errors.select_file_urls = "กรุณาแนบเอกสารหลักฐานการจ่ายเงิน";
    }

    if (data.claim_amount == null) {
      errors.claim_amount = "กรุณาระบุจำนวนเงินที่ใช้ไป";
    }

    return errors;
  };

  const handleOnConfirm = async () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      onConfirm(formData);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        closeButton={
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              right: "16px",
              top: "14px",
              background: "transparent",
            }}
          >
            <path
              d="M6 18L18 6M6 6L18 18"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
        size="xl"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="bg-dark-gray text-white">
                โปรดเลือกไฟล์หลักฐานการจัดงานและการจ่ายเงิน
              </ModalHeader>
              <ModalBody className="flex flex-col gap-y-6 py-6">
                <div className="flex flex-col gap-y-1">
                  <AdjustAmountForm
                    isAdjustAble
                    proposalAmount={currentSubTicket.proposal_amount}
                    onChangeClaimAmount={(amount) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        claim_amount: amount,
                      }));
                    }}
                    isError={errors.claim_amount}
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    className="hidden"
                    alt=""
                    onChange={handleFileChange}
                  />
                  <div>
                    <Button
                      className={`bg-light-gray-300 text-black w-fit px-4 text-md mt-5 rounded-3xl text-sm ${
                        errors.select_file_urls && "border-red-500 border-2"
                      }`}
                      radius="sm"
                      startContent={<div className="text-md text-black">+</div>}
                      onPress={() => fileInputRef.current.click()}
                      isDisabled={selectFiles.length >= 5}
                    >
                      เพิ่มไฟล์หลักฐานการเงิน
                    </Button>
                    <div
                      className={`text-xs py-3  ${
                        errors.select_file_urls
                          ? "text-red-500"
                          : "text-black  text-opacity-50"
                      }`}
                    >
                      <p>กรุณาเพิ่มไฟล์หลักฐานการจ่ายเงินดังนี้</p>
                      <ul className="list-disc pl-6 space-y-1">
                        <li>ใบเบิกเคลม</li>
                        <li>ใบขออนุมัติ</li>
                        <li>ใบเสร็จรับเงิน ใบกำกับภาษี</li>
                        <li>เอกสารหักภาษี ณ ที่จ่าย ใบภ.ง.ด.3 / ภ.ง.ด.53</li>
                        <li>รูปภาพรายการที่เบิก รูปภาพกิจกรรมโดยรวม</li>
                        <li>กรณีเคลมบิลเงินสด กรุณาแนบสำเนาบัตรประชาชนของผู้รับเงิน</li>
                      </ul>
                    </div>

                    <div className="flex gap-x-3 overflow-auto py-2">
                      {selectFiles.map((fileMap, index) => {
                        const [[file, fileName]] = fileMap.entries();
                        return (
                          <React.Fragment key={index}>
                            <div key={index} className="relative flex-shrink-0">
                              <button
                                onClick={() => removeFile(index)}
                                className="absolute -top-2 -right-2 bg-black text-white rounded-full w-6 h-6 pb-0.5 leading-none text-base z-10"
                              >
                                ×
                              </button>

                              {file.type.includes("image") ? (
                                <div className="w-24 h-24 flex-shrink-0">
                                  <img
                                    src={`${AppConstant.STOARGE_ACCOUNT}/ticket-files/${fileName}?${AppConstant.STORAGE_TOKEN}`}
                                    className="rounded-md h-24 w-24 object-cover"
                                    alt=""
                                  />
                                </div>
                              ) : (
                                <div className="h-24 w-24 rounded-xl flex-shrink-0 border-light-gray-300 border-3 bg-white flex items-center justify-center px-5 text-center">
                                  <p className="line-clamp-4 break-words text-sm">
                                    {file.name}
                                  </p>
                                </div>
                              )}
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-end items-end">
                  <Button
                    className="bg-dark-gray text-white mx-5"
                    onPress={handleOnConfirm}
                  >
                    บันทึก
                  </Button>
                  <Button
                    className="bg-light-gray-300 text-white mx-5"
                    variant="light"
                    onPress={onClose}
                  >
                    ยกเลิก
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default AttachClaimDocumentModal;
